import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useBooking } from '../../hooks/useBooking';
import { useSiteColors } from '../../hooks/useSiteColors';

export function FaqSection() {
  const { businessListing } = useBooking();
  const c = useSiteColors();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (!businessListing) return null;

  const baseItems = businessListing.faq ?? [];
  const mentionsCancellation = baseItems.some(
    (i) => /cancel/i.test(i.question + i.answer),
  );
  const items =
    businessListing.cancellation_policy_text && !mentionsCancellation
      ? [
          ...baseItems,
          {
            question: 'What is your cancellation policy?',
            answer: businessListing.cancellation_policy_text,
          },
        ]
      : baseItems;

  if (items.length === 0) return null;


  return (
    <section id="faq" className="py-20">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="mb-10 text-center">
          <p className="text-xs font-semibold tracking-[0.1em] uppercase mb-3" style={{ color: c.link }}>
            FAQ
          </p>
          <h2
            className="text-3xl sm:text-4xl font-bold tracking-tight"
            style={{ color: c.text }}
          >
            Frequently asked questions
          </h2>
        </div>

        <div className="max-w-[760px] mx-auto space-y-3">
          {items.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden"
              style={{ backgroundColor: c.background, border: `1px solid ${c.border}` }}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left gap-4"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
              >
                <span className="text-[15px] font-semibold" style={{ color: c.text }}>
                  {item.question}
                </span>
                <ChevronDown
                  className="w-5 h-5 shrink-0 transition-transform duration-200"
                  style={{
                    color: c.link,
                    transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </button>
              <div
                style={{
                  maxHeight: openIndex === i ? '500px' : '0px',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s ease',
                }}
              >
                <p
                  className="px-6 pb-5 pt-1 text-sm leading-relaxed"
                  style={{ color: c.mutedText }}
                >
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
